
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSyntheticIec as ObiAisTargetSyntheticIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-synthetic-iec.js';
 
 
 

 
 export const ObiAisTargetSyntheticIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-synthetic-iec',
   elementClass: ObiAisTargetSyntheticIecElement,
   events: {
     
   }
  });
 
 